import React, { useContext, useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../../config/AuthContext";
import Login from "../../Login";
import { Content } from "antd/es/layout/layout";
import AppSiderProjectesId from "./menus/AppSiderProjectesId";
import ProjecteIdEnunciat from "./content/ProjecteIdEnunciat";
import { GetProjecteId } from "../../../dao/abp/GetProjecteId";
import ProjecteIdTasques from "./content/ProjecteIdTasques";
import ProjecteIdGestorTasques from "./content/ProjecteIdGestorTasques";
import ProjecteIdGrups from "./content/ProjecteIdGrups";
import ProjecteIdProfessorat from "./content/ProjecteIdProfessorat";
import ProjecteIdValidacions from "./content/ProjecteIdValidacions";
import ProjecteIdConfiguracio from "./content/ProjecteIdConfiguracio";
import { GetProjecteIdConfiguracio } from "../../../dao/abp/GetProjecteIdConfiguracio";
import { GetSprintsByProject } from "../../../dao/abp/GetSprintsByProject";

const ProjectesId = () => {
    const { isLoggedIn, userId, user, setBreadCrumb } = useContext(AuthContext);
    const navigate = useNavigate();
    const { id_projecte } = useParams();
    const [dades, setDades] = useState<any>(); // Fixed syntax
    const [pantalla, setPantalla] = useState(0);
    const [grup, setGrup] = useState<any>();
    const [selectedUid, setSelectedUid] = useState('');
    const [sprints, setSprints] = useState<any[]>([]);
    const [docs, setDocs] = useState<any[]>([]);
    const [selectedSprint, setSelectedSprint] = useState<any>();
    const [selectedDoc, setSelectedDoc] = useState<any>();

    const [enviado, setEnviado] = useState(false);

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (isLoggedIn) {
            checkDades();
            loadInitialData();
        }
    }, [id_projecte]);



    async function loadInitialData() {
        setLoading(true);
        const data = await GetProjecteIdConfiguracio(id_projecte + "");
        setGrup(data);
        setLoading(false);
    }

    async function checkDades() {
        setLoading(true);
        try {
            const data = await GetProjecteId(id_projecte + "", 0);
            let sprintsData = await GetSprintsByProject(id_projecte + "");

            // Safety check: Ensure sprintsData is an array
            if (!Array.isArray(sprintsData)) {
                console.error("GetSprintsByProject returned non-array:", sprintsData);
                sprintsData = [];
            }

            setSprints(sprintsData);

            if (data) {
                console.log(data);
                setDocs(data.docs || []);

                const breadcrumbs = [
                    { nom: 'Home', nav: '/home' },
                    { nom: 'Avaluació', nav: '/abp' }
                ];

                if (user.tipus === "0") {
                    breadcrumbs.push({ nom: `${data.nom}`, nav: `/abp/projectes/${data.id}` });
                } else {
                    breadcrumbs.push(
                        { nom: 'Projectes', nav: '/abp/projectes' },
                        { nom: `${data.nom}`, nav: `/abp/projectes/${data.id}` }
                    );
                }
                setBreadCrumb(breadcrumbs, true);
                setDades(data);
            } else {
                console.error("GetProjecteId returned null/undefined");
                setDocs([]);
                // Optionally redirect or show error if critical data is missing
            }
        } catch (error) {
            console.error("Error checking dades:", error);
        } finally {
            setLoading(false);
        }
    }

    function setPnt(value: number, isSprint: boolean, sprint: string) {
        if (!isSprint) {
            setPantalla(value);
        } else {
            setSelectedSprint(sprints.find(value1 => {
                if (value1.id + "" === sprint + "") {
                    return value1;
                }
            }));
            setPantalla(2);
        }
    }
    function setPntDocs(value: number, isDoc: boolean, doc: string) {
        if (!isDoc) {
            setPantalla(value);
        } else {
            setSelectedDoc(docs.find(value1 => {
                if (value1.id + "" === doc + "") {
                    return value1;
                }
            }));
            setPantalla(1); // 👈 usamos la pantalla del "Enunciat"
        }
    }


    if (isLoggedIn) {
        return (
            <>
                <AppSiderProjectesId
                    setPantalla={setPnt}
                    setPantalLaDocs={setPntDocs}
                    currentVal={0}
                    sprints={sprints}
                    docs={docs}
                    refresh={checkDades} // Pass refresh function
                />
                <Content style={{ padding: '0 24px', minHeight: 280 }}>
                    {pantalla === 0 && <ProjecteIdGrups />}
                    {pantalla === 1 && <ProjecteIdEnunciat doc={selectedDoc} />}
                    {pantalla === 2 && <ProjecteIdTasques sprint={selectedSprint} />}
                    {pantalla === 3 && <ProjecteIdGestorTasques sprint={selectedSprint} />}
                    {pantalla === 4 && <ProjecteIdProfessorat />}
                    {pantalla === 5 && <ProjecteIdValidacions />}
                    {pantalla === 6 && <ProjecteIdConfiguracio data={grup} loadData={loadInitialData} />}

                </Content>
            </>
        );
    } else {
        return (
            <Login />
        );
    }
};

export default ProjectesId;
